import * as React from 'react';
import { ChatHeader } from '../../components/chat-header';
import { ChatLayout } from '../../components/chat-layout';
import { ChatMessages } from '../../components/chat-messages';
import { ChatTextarea } from '../../components/message-text-area';

const Chat = () => (
  <ChatLayout enableActionMenu header={<ChatHeader />} content={<ChatMessages />} footer={<ChatTextarea />} />
);

export default Chat;
